import { styled } from "@mui/system"
import { Box } from "@mui/material"

export const PerformanceBarWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "0px",
  lineHeight: 0,
  fontSize: 0,
  whiteSpace: "nowrap",
  paddingBottom: "4px",
  position: "relative",
  svg: {
    "&.completed": {
      color: "var(--green-blue)",
    },
    "&.assigned": {
      color: "var(--mint)",
    },
    "&.unassigned": {
      color: "var(--amber)",
    },
  },
})
